/**
 * File size unit abbreviations
 */
enum FileSizeUnit {
	BIT = "bit",
	BYTES = "B",
	KILOBYTES = "KB",
	MEGABYTES = "MB",
	GIGABYTES = "GB",
	TERRABYTES = "TB"
}

export default FileSizeUnit